import cheader from '@/components/header/index.vue'
import vueSeamlessScroll from 'vue-seamless-scroll'

export default {
	name: 'buyer',
	data() {
		return {
			serverUrl: this.$store.state.config.serverUrl,
			banners: [],
			search: {
				name: ''
			},
			total: 0,
			curpage: 1,
			suppliers: [],
			newers: [],
			classOption: {
				step: 0.5,
				limitMoveNum: 1,
				openTouch: false,
				hoverStop: true
			}
		}
	},
	components: {
		cheader,
		vueSeamlessScroll
	},
	created() {
		this.index(1)
		this.bannerIndex()
		this.newerIndex()
	},
	methods: {
		go(url) {
			this.$router.push(url)
		},
		index(page) {
			this.$http.get('/api/purchaserPage', {params: {name: this.search.name}}).then((res) => {
				this.suppliers = res.data.data
				this.total = res.data.total
			})
		},
		bannerIndex() {
			this.$http.get('/api/innerBanner').then((res) => {
				this.banners = res.data.data
			})
		},
		newerIndex() {
			this.$http.get('/api/latestJoin').then((res) => {
				this.newers = res.data.latestPurchasers
			})
		}
	}
}


// WEBPACK FOOTER //
// ./src/views/home/buyer/index.js